/**
 * Create an object of key/value pairs based on a query string
 *
 * @param {string} query - String from a URL
 * @returns {object} Object of key/value pairs
 */
export const parseSearchQuery = (query?: string): Record<string, string> => {
  try {
    const sanitizedQuery = query.startsWith('?') ? query.slice(1) : query

    return sanitizedQuery
      .split('&')
      .map(param => param.split('='))
      .filter(([, value]) => value !== undefined && value !== '')
      .reduce<Record<string, string>>((acc, [key, value]) => {
        acc[key] = decodeURIComponent(value)
        return acc
      }, {})
  } catch {
    return {}
  }
}
